import { render, staticRenderFns } from "./opportunitySelection.vue?vue&type=template&id=6309515c&scoped=true"
import script from "./opportunitySelection.vue?vue&type=script&lang=js"
export * from "./opportunitySelection.vue?vue&type=script&lang=js"
import style0 from "./opportunitySelection.vue?vue&type=style&index=0&id=6309515c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6309515c",
  null
  
)

export default component.exports